import { useState } from 'react';
import Layout from '../componentes/Layout';
import FinanceiroMes from '../componentes/FinanceiroMes';
import FinanceiroAno from '../componentes/FinanceiroAno';
import FinanceiroConciliacao from '../componentes/FinanceiroConciliacao';
import FinanceiroAjustes from '../componentes/FinanceiroAjustes';
import FinanceiroParceiroDeDeus from '../componentes/FinanceiroParceiroDeDeus';
import { useAutenticacao } from '../lib/auth';

const MESES = [
  'Janeiro',
  'Fevereiro',
  'Marco',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
];

function hojeSP(): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Sao_Paulo' }).format(new Date());
}

type Aba = 'mes' | 'ano' | 'conciliacao' | 'pd' | 'ajustes';

export default function Financeiro() {
  const { usuario } = useAutenticacao();
  const ehAdmin = usuario?.papel === 'admin';

  const [aba, setAba] = useState<Aba>('mes');
  const [ano, setAno] = useState(Number(hojeSP().slice(0, 4)));
  const [mes, setMes] = useState(Number(hojeSP().slice(5, 7)));

  const abas: { chave: Aba; rotulo: string }[] = [
    { chave: 'mes', rotulo: 'Mês' },
    { chave: 'ano', rotulo: 'Ano' },
    { chave: 'conciliacao', rotulo: 'Conciliação' },
    { chave: 'pd', rotulo: 'Parceiro de Deus' },
    ...(ehAdmin ? [{ chave: 'ajustes' as Aba, rotulo: 'Ajustes' }] : []),
  ];

  // o seletor de mes so faz sentido nas abas que olham um mes
  const mostrarMes = aba === 'mes' || aba === 'conciliacao' || aba === 'pd';

  return (
    <Layout
      titulo="Tesouraria"
      subtitulo="Entradas, saidas, conciliação e prestacao de contas."
      acoes={
        <div className="flex gap-2">
          {mostrarMes && (
            <select
              value={mes}
              onChange={(e) => setMes(Number(e.target.value))}
              className="rounded-xl border border-tinta-200 bg-white px-3 py-2 text-sm"
            >
              {MESES.map((m, i) => (
                <option key={m} value={i + 1}>
                  {m}
                </option>
              ))}
            </select>
          )}
          <select
            value={ano}
            onChange={(e) => setAno(Number(e.target.value))}
            className="rounded-xl border border-tinta-200 bg-white px-3 py-2 text-sm"
          >
            {[ano - 1, ano, ano + 1].map((a) => (
              <option key={a} value={a}>
                {a}
              </option>
            ))}
          </select>
        </div>
      }
    >
      <div className="mb-5 flex flex-wrap gap-1 border-b border-tinta-200">
        {abas.map((a) => (
          <button
            key={a.chave}
            type="button"
            onClick={() => setAba(a.chave)}
            className={
              aba === a.chave
                ? 'border-b-2 border-tinta-900 px-4 py-2 text-sm font-medium text-tinta-900'
                : 'border-b-2 border-transparent px-4 py-2 text-sm text-tinta-500 hover:text-tinta-700'
            }
          >
            {a.rotulo}
          </button>
        ))}
      </div>

      {aba === 'mes' && <FinanceiroMes ano={ano} mes={mes} />}
      {aba === 'ano' && <FinanceiroAno ano={ano} />}
      {aba === 'conciliacao' && <FinanceiroConciliacao ano={ano} mes={mes} />}
      {aba === 'pd' && <FinanceiroParceiroDeDeus ano={ano} mes={mes} />}
      {aba === 'ajustes' && ehAdmin && <FinanceiroAjustes />}
    </Layout>
  );
}
